import { render, staticRenderFns } from "./notifiactionTabs.vue?vue&type=template&id=3ff70678&scoped=true"
import script from "./notifiactionTabs.vue?vue&type=script&lang=js"
export * from "./notifiactionTabs.vue?vue&type=script&lang=js"
import style0 from "./notifiactionTabs.vue?vue&type=style&index=0&id=3ff70678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff70678",
  null
  
)

export default component.exports